<div *ngIf="inputProject.withPlacement">
  <mat-card class="top-card mat-elevation-z0 no-padding overflowHidden">
    <div
      [class.collapsed]="isCollapsed"
      class="section-header padding d-flex  justify-content-between overflowHidden clickable"
      (click)="isCollapsed = !isCollapsed"
      [attr.aria-expanded]="!isCollapsed"
    >
      <div class="projectTitle flexer">Werfbezoek</div>
      <button
        mat-icon-button
        class="arrow-button pull-right"
        style="margin-top:5px"
      >
        <mat-icon svgIcon="arrow-up"></mat-icon>
      </button>
    </div>
    <div class="padding" [collapse]="isCollapsed" [isAnimated]="!safari">
      <mat-card class="internal-form mat-elevation-z0">
        <div class="internal-form-title">
          <div class="internal-form-title-text">Intern</div>
        </div>
        <yes-no
          [title]="'Werfbezoek nodig?'"
          [extraInstructions]="'Geef hier extra informatie over het bezoek in.'"
          [value]="inputProject.projectPlacement.siteVisit"
          (answer)="siteVisitChanged($event)"
          [inputText]="inputProject.projectPlacement.extraInfoSiteVisit"
          (answeredText)="extraInfoSiteVisitChanged($event)"
        ></yes-no>
        <yes-no
          *ngIf="inputProject.projectPlacement.siteVisit"
          [title]="'Werfbezoek uitgevoerd'"
          [showExtraInstructionsOn]="'never'"
          [value]="inputProject.projectPlacement.siteVisitExecuted"
          (answer)="siteVisitExecutedChanged($event)"
        ></yes-no>
        <mat-form-field appearance="outline">
          <mat-label>Uiterste datum werfbezoek</mat-label>
          <input
            matInput
            [matDatepicker]="deadlineSiteVisitPicker"
            placeholder="Selecteer een datum"
            [(ngModel)]="inputProject.projectPlacement.deadlineSiteVisit"
            (ngModelChange)="deadlineSiteVisitChanged($event)"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="deadlineSiteVisitPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #deadlineSiteVisitPicker></mat-datepicker>
        </mat-form-field>

        <form class="form">
          <div class="form-sub-title">Naam medewerker</div>

          <mat-form-field class="" appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              name="employee"
              required
              [(ngModel)]="inputProject.projectPlacement.employee"
              (ngModelChange)="employeeChange($event)"
              [compareWith]="compareEntities"
            >
              <mat-option
                *ngFor="let option of employeeChoices"
                [value]="option"
              >
                {{ option.user.firstName }} {{ option.user.lastName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </form>

        <yes-no
          [title]="'Aanrekenen'"
          [showExtraInstructionsOn]="null"
          [value]="inputProject.projectPlacement.charge"
          (answer)="chargeChanged($event)"
        ></yes-no>
      </mat-card>
    </div>
  </mat-card>
</div>
